import { useCallback, useMemo, useState } from 'react';

import { StepsProps } from 'antd';

type CurrentStep = NonNullable<StepsProps['current']>;

export type NextStep = () => void;
export type PreviousStep = () => void;

export function useSteps() {
    const [currentStep, setCurrentStep] = useState<CurrentStep>(0);

    const nextStep = useCallback(() => setCurrentStep(prevState => prevState + 1), []);
    const previousStep = useCallback(() => setCurrentStep(prevState => prevState - 1), []);

    return useMemo(() => ({
        currentStep,
        nextStep,
        previousStep,
    }), [currentStep, nextStep, previousStep]);
}